import type { CallDetails, Step } from '../types.action-flow'

/**
 * Build call details from a step at execution time
 * Note: Must be called during execution, not pre-computed, because getCall()
 * may depend on state from previous steps
 */
export function buildCallDetails(step: Step): CallDetails {
  try {
    switch (step.type) {
      case 'singleTx':
        return { call: step.getCall() }
      case 'batchTx':
        return { calls: step.getCalls.map(getCall => getCall()) }
      case 'signature':
        // For signature requests, we don't have getTypedData/getMessage in the current types
        // This is a placeholder for when signature payloads need to be captured
        return { signaturePayload: { type: 'signature', label: step.label } }
    }
  } catch (error) {
    console.error('Failed to build call/s for execution:', error)
    throw error
  }
}
